/**
 * Storage utility functions for file handling and normalization
 */

export const normalizeStoragePath = (path: string): string => {
  if (!path) return '';
  
  // Strip public URL prefix
  if (path.includes('/storage/v1/object/public/')) {
    const parts = path.split('/storage/v1/object/public/');
    return parts[1].split('?')[0];
  }
  
  // Strip signed URL prefix
  if (path.includes('/storage/v1/object/sign/')) {
    const parts = path.split('/storage/v1/object/sign/');
    return parts[1].split('?')[0];
  }
  
  // Remove query parameters
  return path.split('?')[0];
};

export type FileType = 'image' | 'pdf' | 'unknown';

export const getFileType = (fileName: string): FileType => {
  if (!fileName) return 'unknown';
  
  const ext = fileName.split('.').pop()?.toLowerCase();
  
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(ext || '')) {
    return 'image';
  }
  
  if (ext === 'pdf') {
    return 'pdf';
  }
  
  return 'unknown';
};

export const isPreviewableFile = (fileName: string): boolean => {
  return getFileType(fileName) !== 'unknown';
};

export const formatFileSize = (bytes?: number): string => {
  if (!bytes) return 'Onbekend';
  
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
